export function basicVoucherJudge(datas, vouchers) {
    // 財會檢核狀態需為「待檢核」
    if (datas.detail?.vocherStatus !== 0) return false;

    // 有傳票
    if (vouchers.length <= 0) return false;
    return true;
}

export function getTotalCrd(vouchers, accno) {
    let sum = 0;
    vouchers.forEach((voucher) => {
        if (!voucher.cnl) {
            voucher.accountItems.forEach((item) => {
                if (item.accno === accno) {
                    sum += item.crD_NTD;
                }
            });
        }
    });
    return sum;
}
export function getTotalDeb(vouchers, accno) {
    let sum = 0;
    vouchers.forEach((voucher) => {
        if (!voucher.cnl) {
            voucher.accountItems.forEach((item) => {
                if (item.accno === accno) {
                    sum += item.deB_NTD;
                }
            });
        }
    });
    return sum;
}
